import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Z_LAYERS } from '../constants/zLayers';

interface ToastProps {
  message: string;
  isVisible: boolean;
}

export default function Toast({ message, isVisible }: ToastProps) {
  if (!isVisible) return null;

  return (
    <div
      className="absolute top-4 left-0 right-0 mx-auto w-fit flex items-center gap-2 bg-gray-800/90 backdrop-blur-sm text-white px-4 py-2 rounded-xl shadow-lg animate-fade-in border border-gray-700/50"
      style={{ zIndex: Z_LAYERS.TOAST }}
    >
      <CheckCircle className="w-4 h-4 text-green-400" />
      <span>{message}</span>
    </div>
  );
}
